<div class="nsc-card"><ng-content></ng-content></div>
